import { Column, Row, Text } from "@bridgesplit/ui";
import { TokenInputWithPrice, useBalanceChecker, BalanceDisplay, GetAssetButton } from "app/components/common";

import { useWindContext } from "../WindContext";
import { useLoopContext } from "../../LoopContext";

const LABEL = "Deposit";

export default function ManualWindCollateral() {
    const { form, setForm } = useWindContext();
    const { loopExpanded } = useLoopContext();

    const collateralToken = loopExpanded?.collateralToken;
    const principalToken = loopExpanded?.principalToken;

    const { balance, insufficientBalance, isLoading } = useBalanceChecker({
        mint: collateralToken?.mint,
        amount: form.collateralAmount,
        solanaFeeBuffer: 0.02
    });

    function setMax(maxAmount: number | undefined) {
        setForm((prev) => ({
            ...prev,
            collateralAmount: maxAmount
        }));
    }

    if (!collateralToken) {
        return null;
    }

    return (
        <Column spacing={0.5}>
            <Row spaceBetween>
                <Text variant="body2" color="caption">
                    {LABEL}
                </Text>
                <GetAssetButton
                    routeType={loopExpanded?.loopVault.routeType}
                    buyToken={collateralToken}
                    sellToken={principalToken}
                    supportingToken={loopExpanded?.inputToken} // for orca support
                    isWhirlpoolPoolSelectedInput={loopExpanded?.collateralToken.mint === collateralToken?.mint} // for orca support
                    stabblePoolLink={undefined}
                />
            </Row>
            <TokenInputWithPrice
                metadata={collateralToken}
                selectToken={null}
                value={form.collateralAmount}
                setValue={(collateralAmount) =>
                    setForm((prev) => ({
                        ...prev,
                        collateralAmount
                    }))
                }
                belowInput={
                    <BalanceDisplay
                        balance={balance}
                        metadata={collateralToken}
                        insufficientBalance={insufficientBalance}
                        isLoading={isLoading}
                        setMax={setMax}
                    />
                }
            />
        </Column>
    );
}
